
export default function About() {

  return (
    <div className="about-container">
      <h1>About KnowYourPay</h1>

      {/* Platform Overview */}
      <p>
        Know Your Pay is an automated reporting platform built for small businesses
        that want instant insights without complex tools. By simply uploading Excel
        or CSV files, businesses can analyze inventory, sales, revenue, costs, and
        profit in seconds.
      </p>

      <p>
        The platform automatically generates clear, structured reports so business
        owners can understand performance without formulas, spreadsheets, or
        accounting software. Know Your Pay helps track sales trends, monitor costs,
        and evaluate profitability with minimal effort.
      </p>

      {/* Mission */}
      <p>
        Our mission is to simplify business reporting by providing instant, accurate,
        and actionable reports. Upload your data, visualize trends, and make smarter
        business decisions without complicated software or accounting expertise.
      </p>

      {/* Services */}
      <p>
        Know Your Pay empowers small businesses, startups, and analysts to quickly
        understand financial performance. Services include automated analysis of
        sales, cost, profit, and inventory, all presented in clear, easy-to-read reports.
      </p>

      {/* Benefits */}
      <p>
        Whether you run a retail store, service business, or growing startup, Know
        Your Pay turns raw data into actionable insights that help business owners
        track trends, monitor performance, and make informed decisions with confidence.
      </p>
    </div>
  );
}
